// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../../graphql/api/index';

import { gql } from 'graphql-tag';
import { ImageLargeFragmentDoc } from '../imageLarge.fragment.generated';
export const ComponentQuoteFragmentDoc = gql`
    fragment componentQuote on ComponentQuote {
  hasBackgroundImage
  quoteImage: image {
    ...imageLarge
  }
  quote
  author
  size
  showQuotationMarks
}
    ${ImageLargeFragmentDoc}`;